<template>
  <v-app>
    <PageHeader />

    <v-main fluid class="mb-16">
      <router-view @alert-event="doShowAlert"></router-view>
    </v-main>

    <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
    <v-snackbar v-model="showAlert" :timeout="alertTimeout" :color="alertColor">
      {{ alertText }}
      <v-btn text @click="showAlert = false">
        Cerrar
      </v-btn>
    </v-snackbar>
    <!-- FIN BLOQUE ESTADO PETICIONES -->

    <PageFooter />
  </v-app>
</template>

<script>
import PageHeader from '@Base/pages/common/PageHeader';
import PageFooter from '@Base/pages/common/PageFooter';
import { loadLanguageAsync } from '@Base/plugins/i18n.js'
import '@Base/assets/App.css'

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter
  },
  data: () => ({
    loadedLangs: false,
    showAlert: false,
    alertText: '',
    alertColor: '',
    alertTimeout: 6000,
  }),

  methods: {
    doShowAlert(payload) {
      this.alertColor = payload.color;
      this.alertText = payload.text;
      this.showAlert = true;
    },

    cambiarIdioma(lang) {
      loadLanguageAsync(lang).finally(() => this.$showMessage.success('Idioma cambiado'));
    }
  },

  beforeCreate() {
    loadLanguageAsync('es-ES', 1).then(() =>
      this.loadedLangs = true
    );
  },
}
</script>
<style lang="scss" scoped>
.v-application {
  font-family: 'Lato', sans-serif;
}
</style>
